export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.prototype.eventHub = new Vue()
  }
}
